<template>
  <div>
   <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody>
                            <tr>
	          		<td ref="tdlbl_咨询服务费" class="el-table__cell tdlbl tdw17" colspan="1">
	                    <span v-field-lbl="'paymentAmount'" class="field">咨询服务费</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw33" colspan="2">
	          				{{ vo.fgsglFeeItem.paymentAmount }}
	                </td>
	          		<td ref="tdlbl_到期日期 " class="el-table__cell tdlbl tdw17" colspan="1">
	                    <span v-field-lbl="'endDate'" class="field">到期日期 </span>
	                </td>
	          		<td class="el-table__cell tdcont tdw33" colspan="2">
	          				{{ getTime(vo.fgsglFeeItem.endDate) }}
	                </td>
	          	</tr>
                        </tbody>
                    </table>
  </div>
</template>

<script>
export default {
    props: {
        vo: { type: Object, default: function() { return {} } }
    },
    methods: {
        getTime(time) {
            return this.$moment(time).format('YYYY-MM-DD')
        }
    }
}
</script>

<style>

</style>
